import { useParams } from 'react-router';

import { MagentoStep1, MagentoStep2 } from './MagentoSteps';
import { useGetIwocapayIntegrationInterest } from '../../../../api/lending/lapiHooks';
import externalLinkSVG from '../../../../assets/externalLink.svg';
import tickSVG from '../../assets/tick.svg';
import { useGetIntegrationStatus } from '../../hooks/useGetIntegrationStatus.hook';
import { Magento } from '../../Integrations';
import { IntegrationsTitle } from '../IntegrationsTitle/IntegrationsTitle';
import { RegisterInterestButton } from '../RegisterInterestButton/RegisterInterestButton';

export function MagentoBody() {
  const { integrationParam } = useParams();

  const { integrationStatus } = useGetIntegrationStatus({
    integrationId: Magento.id,
  });
  const isConnected = integrationStatus === 'CONNECTED';

  const { iwocapayIntegrationInterest, loadingIwocapayIntegrationInterest } =
    useGetIwocapayIntegrationInterest();

  const interestRegistered =
    Magento.id && iwocapayIntegrationInterest?.includes(Magento.id);

  const userHasInteracted = isConnected || interestRegistered;

  if (integrationParam !== Magento.id) {
    return null;
  }
  if (loadingIwocapayIntegrationInterest) {
    return null;
  }
  return (
    <div className="text-left">
      <div className="flex flex-wrap items-center justify-between max-800:flex-col max-800:items-start max-800:pt-[2.25rem]">
        <IntegrationsTitle integration={Magento} />
        <div className="max-800:w-full max-800:pt-l">
          {userHasInteracted && (
            <div className="text-m font-bold text-success-drk">
              <img src={tickSVG} alt="Tick Icon" className="pr-[0.7rem]" />
              {isConnected ? 'Connected' : 'Request sent'}
            </div>
          )}
          <RegisterInterestButton integrationName={Magento.id} />
        </div>
      </div>
      <div className="border-b border-structure-80 pb-[3rem] text-m font-reg">
        <div>
          {!userHasInteracted && (
            <p>
              Build multi-channel commerce experiences for B2B and B2C customers
              on a single platform. Endlessly flexible, extensible and scalable.
              <br />
              <br />
              <b>
                When you connect iwocaPay to {Magento.company_name} it'll
                automatically:
              </b>
              <ul>
                <li>
                  add iwocaPay as a payment method on your{' '}
                  {Magento.company_name} checkout
                </li>
                <li>
                  reconcile all iwocaPay payments with your{' '}
                  {Magento.company_name} store data.
                </li>
              </ul>
            </p>
          )}
          {userHasInteracted && (
            <div>
              <p>
                <b>
                  We’ve got your request to access the {Magento.company_name}{' '}
                  plugin.
                </b>
                <br />
                Not long now till you’ve added iwocaPay to your store checkout.
                <br />
                <br />
                Here’s what happens next:
              </p>
              <div className="mt-[2rem] border-t border-structure-80 pt-l">
                <MagentoStep1 />
                <MagentoStep2 />
              </div>
            </div>
          )}
          <div>
            <a
              href="https://ecommerce-api.iwoca.com/guides/plugin-solution/magento/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center pt-[1.25rem] text-m font-bold text-primary-40 no-underline"
            >
              {Magento.company_name} FAQs
              <img src={externalLinkSVG} alt="" className="pl-s" />
            </a>
          </div>
        </div>
      </div>
      <div className="inline-flex pt-[3rem] max-800:block max-800:w-full">
        <RegisterInterestButton integrationName={Magento.id} />
      </div>
    </div>
  );
}
